module.exports = __webpack_public_path__ + "img/visapay-1.141cb4e0.png";